import React, { useContext, useEffect, useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import SourceFilesInput from '../../modals/seller/form/SourceFilesInput/SourceFilesInput';
import { SubmitFormContext } from '../../context';
import { useSubmitField } from '../../hooks/useSubmitField';
import { getSourceFilesInputNameByDeviationId } from '../../modals/seller/redux/helpers';

interface Props {
  className?: string;
}

const ExclusiveAttachmentsField: React.FC<Props> = ({ className }) => {
  const submitFormContext = useContext(SubmitFormContext);
  const { deviation, adoptable } = submitFormContext?.initResponse || {};
  const defaultValue = useMemo(
    () =>
      (adoptable?.assets || []).map(asset => ({
        name: asset.filename,
        size: asset.filesize,
        type: asset.type,
        deviationId: asset.isOriginal ? 0 : asset.deviationId,
        fileId: asset.fileId,
      })),
    [adoptable?.assets]
  );

  const {
    field: { onChange },
  } = useSubmitField('exclusiveAttachments', {
    submitAdapter: ({ exclusiveAttachments }) => ({
      includeOriginal:
        exclusiveAttachments.filter(attachment => attachment.deviationId === 0).length > 0,
    }),
  });

  const assetsFieldName = getSourceFilesInputNameByDeviationId(deviation?.deviationId);
  const assets = useWatch({ name: assetsFieldName });

  useEffect(() => {
    if (assets) {
      onChange(assets);
    }
  }, [assets, onChange]);

  if (!deviation) {
    // should never get here
    return null;
  }

  return <SourceFilesInput deviation={deviation} defaultValue={defaultValue} />;
};
ExclusiveAttachmentsField.displayName = 'ExclusiveAttachmentsField';

export default ExclusiveAttachmentsField;
